import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect } from 'react';
// Migrated to Paraglide JS - removed useTranslation
import { AnimatePresence } from 'framer-motion';
import { ThemeProvider } from '@emotion/react';
import { HeroUIProvider } from '@heroui/react';
import { ChatModalWrapper, chatModalTheme, ModalOverlay } from './ChatModal.styles';
import { useAIChatModalState } from './hooks/useAIChatModalState';
import { useAIChatModalHandlers } from './hooks/useAIChatModalHandlers';
import AIChatSidebarView from './AIChatSidebarView';
import AIChatMainView from './AIChatMainView';
const AIChatModal = ({ isOpen, onClose, isSidebarMode = false, onSwitchToUserChat })=>{
    // Migrated to Paraglide JS - removed useTranslation
    // Debug: 언어 변경 감지 - migration temporary logging
    useEffect(()=>{
        console.log('[ChatModal] Paraglide migration completed'); // Migrated to Paraglide JS - temporary debug
    }, []);
    // Use extracted state hook
    const state = useAIChatModalState({
        isSidebarMode
    });
    // Use extracted handlers hook
    const handlers = useAIChatModalHandlers({
        isMinimized: state.isMinimized,
        setIsMinimized: state.setIsMinimized,
        isMaximized: state.isMaximized,
        setIsMaximized: state.setIsMaximized,
        setSize: state.setSize,
        setPosition: state.setPosition,
        setIsCreatingChat: state.setIsCreatingChat,
        sendMessage: state.sendMessage,
        createChat: state.createChat,
        clearChatMessages: state.clearChatMessages,
        onClose,
        handleDragTouchStart: state.handleDragTouchStart,
        handlePinchStart: state.handlePinchStart,
        currentChatId: state.currentChatId
    });
    // 모바일 환경에서 콘솔 로그 추가
    useEffect(()=>{
        if (isOpen) {
            console.log('[ChatModal] Component state', {
                isMobile: state.isMobile,
                isOpen,
                isMinimized: state.isMinimized,
                isMaximized: state.isMaximized,
                currentView: state.currentView,
                position: state.position,
                size: state.size,
                isDragging: state.isDragging,
                isResizing: state.isResizing,
                isPinching: state.isPinching
            });
        }
    }, [
        isOpen,
        state.isMobile,
        state.isMinimized,
        state.isMaximized,
        state.currentView,
        state.position,
        state.size,
        state.isDragging,
        state.isResizing,
        state.isPinching
    ]);
    // 사이드바 모드일 때는 완전히 다른 레이아웃 렌더링
    if (isSidebarMode) {
        return /*#__PURE__*/ _jsx(AIChatSidebarView, {
            isMobile: state.isMobile,
            isAutoActivated: state.isAutoActivated,
            isCreatingChat: state.isCreatingChat,
            isGenerating: state.isGenerating,
            currentView: state.currentView,
            currentChatId: state.currentChatId,
            messages: state.currentChat?.messages || [],
            onSwitchToUserChat: onSwitchToUserChat,
            onClose: onClose,
            setCurrentView: state.setCurrentView,
            handleCopyMessage: handlers.handleCopyMessage,
            handleSendMessage: handlers.handleSendMessage,
            handleCreateNewChat: handlers.handleCreateNewChat,
            handleClearMessages: handlers.handleClearMessages,
            stopGeneration: state.stopGeneration
        });
    }
    return /*#__PURE__*/ _jsx(AnimatePresence, {
        children: isOpen && /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(ModalOverlay, {}),
                /*#__PURE__*/ _jsx(HeroUIProvider, {
                    children: /*#__PURE__*/ _jsx(ThemeProvider, {
                        theme: chatModalTheme,
                        children: /*#__PURE__*/ _jsx(ChatModalWrapper, {
                            children: /*#__PURE__*/ _jsx(AIChatMainView, {
                                // State props
                                isMobile: state.isMobile,
                                isMinimized: state.isMinimized,
                                isMaximized: state.isMaximized,
                                isCompact: state.isCompact,
                                position: state.position,
                                size: state.size,
                                currentView: state.currentView,
                                currentChatId: state.currentChatId,
                                isDragging: state.isDragging,
                                isResizing: state.isResizing,
                                isCreatingChat: state.isCreatingChat,
                                isGenerating: state.isGenerating,
                                messages: state.currentChat?.messages || [],
                                // Handler props
                                handleMouseDown: state.handleMouseDown,
                                handleTouchStart: handlers.handleTouchStart,
                                setCurrentView: state.setCurrentView,
                                toggleMaximize: handlers.toggleMaximize,
                                handleCopyMessage: handlers.handleCopyMessage,
                                handleSendMessage: handlers.handleSendMessage,
                                handleCreateNewChat: handlers.handleCreateNewChat,
                                handleClearMessages: handlers.handleClearMessages,
                                handleResizeStart: state.handleResizeStart,
                                stopGeneration: state.stopGeneration,
                                onClose: onClose,
                                // Sidebar mode flag
                                isSidebarMode: isSidebarMode,
                                onSwitchToUserChat: onSwitchToUserChat
                            })
                        })
                    })
                })
            ]
        })
    });
};
export default AIChatModal;
